export const mlPageData = {
  hero: {
    title: 'Machine Learning Solutions',
    description:
      'Harness the power of artificial intelligence and machine learning to predict trends, automate decisions, and uncover hidden patterns that drive competitive advantage.',
  },
  overview: {
    title: 'Why Machine Learning Transforms Business',
    paragraphs: [
      'Machine learning represents the next frontier in business intelligence, enabling organizations to move beyond descriptive analytics to predictive and prescriptive insights. Our ML solutions help you anticipate market changes, optimize operations, and create personalized customer experiences.',
      'From recommendation engines that boost sales to predictive maintenance that prevents costly downtime, our machine learning models are designed to solve real business problems and deliver measurable ROI.',
      'We specialize in making complex AI accessible, providing end-to-end ML solutions from data preparation and model development to deployment and monitoring in production environments.',
    ],
    stats: [
      { number: '65%', label: 'Average Accuracy Improvement' },
      { number: '45%', label: 'Cost Reduction in Operations' },
      { number: '80%', label: 'Faster Decision Making' },
      { number: '95%', label: 'Model Deployment Success Rate' },
    ],
  },
  services: {
    title: 'Our ML Services',
    items: [
      {
        icon: '🔮',
        title: 'Predictive Modeling',
        description:
          'Build sophisticated models that forecast future trends, customer behavior, and business outcomes with high accuracy.',
        features: [
          'Sales and demand forecasting',
          'Customer lifetime value prediction',
          'Risk assessment models',
          'Market trend analysis',
          'Financial planning models',
        ],
      },
      {
        icon: '👥',
        title: 'Customer Segmentation',
        description: 'Discover hidden customer patterns and create targeted marketing strategies using advanced clustering algorithms.',
        features: [
          'Behavioral segmentation',
          'RFM analysis',
          'Personalization engines',
          'Churn prediction',
          'Cross-sell/upsell optimization',
        ],
      },
      {
        icon: '📊',
        title: 'Demand Forecasting',
        description: 'Optimize inventory, staffing, and resource allocation with accurate demand prediction models.',
        features: [
          'Inventory optimization',
          'Supply chain planning',
          'Resource allocation',
          'Seasonal adjustment models',
          'Multi-location forecasting',
        ],
      },
      {
        icon: '🚨',
        title: 'Anomaly Detection',
        description: 'Identify unusual patterns, fraud, and operational issues in real-time with intelligent monitoring systems.',
        features: [
          'Fraud detection systems',
          'Quality control monitoring',
          'Network security alerts',
          'Equipment failure prediction',
          'Process optimization',
        ],
      },
    ],
  },
  process: {
    title: 'Our ML Development Process',
    steps: [
      { number: 1, title: 'Problem Definition', description: 'Clearly define business objectives, success metrics, and identify the most suitable ML approach for your specific use case.' },
      { number: 2, title: 'Data Collection & Preparation', description: 'Gather, clean, and transform data from multiple sources, ensuring quality and relevance for model training.' },
      { number: 3, title: 'Feature Engineering', description: 'Create meaningful features from raw data that enhance model performance and interpretability.' },
      { number: 4, title: 'Model Development', description: 'Build, train, and validate multiple algorithms to find the best performing model for your specific requirements.' },
      { number: 5, title: 'Model Evaluation', description: 'Rigorously test model performance using appropriate metrics and validation techniques to ensure reliability.' },
      { number: 6, title: 'Deployment & Monitoring', description: 'Deploy models to production and implement continuous monitoring to maintain optimal performance over time.' },
    ],
  },
  technologies: {
    title: 'ML Technologies & Frameworks',
    items: [
      { icon: '🐍', name: 'Python' },
      { icon: '🧠', name: 'TensorFlow' },
      { icon: '🔥', name: 'PyTorch' },
      { icon: '📊', name: 'Scikit-learn' },
      { icon: '☁️', name: 'AWS SageMaker' },
      { icon: '📈', name: 'XGBoost' },
      { icon: '🌐', name: 'Apache Spark' },
      { icon: '🔄', name: 'MLflow' },
    ],
  },
  gallery: {
    title: 'ML Use Cases & Success Stories',
    description: 'Explore real-world applications of our machine learning solutions across industries',
    items: [
      { icon: '🛒', title: 'E-commerce Recommendation Engine', description: 'Increased sales by 35% through personalized product recommendations using collaborative filtering and deep learning algorithms.' },
      { icon: '🏭', title: 'Predictive Maintenance System', description: 'Reduced equipment downtime by 60% using IoT sensor data and machine learning to predict failures before they occur.' },
      { icon: '🎯', title: 'Customer Churn Prediction', description: 'Improved customer retention by 40% through early identification of at-risk customers and targeted intervention strategies.' },
    ],
  },
  cta: {
    title: 'Ready to Unlock the Power of Machine Learning?',
    description: "Let's discuss how our machine learning solutions can transform your business operations and drive innovation.",
    buttonText: 'Start Your ML Journey',
  },
};
